function copyURI(evt) {
  evt.preventDefault();
  navigator.clipboard
    .writeText(window.location.href)
    .then(() => {
      const tooltip = document.querySelector('.tooltip');
      console.log(tooltip);
      if (tooltip) {
        tooltip.classList.remove('hidden');
        setTimeout(() => {
          tooltip.classList.add('hidden');
        }, 2000); // Hide tooltip after 2 seconds
      } else {
        console.error('Tooltip element not found');
      }
    })
    .catch((err) => {
      console.error('Failed to copy: ', err);
    });
}

document.addEventListener('DOMContentLoaded', () => {
  const copyLinks = document.querySelectorAll('.copy-btn');

  for (const copyLink of copyLinks) {
    copyLink.addEventListener('click', copyURI);
  }
});
